import { AxiosResponse } from 'axios';
import { axiosIntance } from '../../../config/ApiConfig';
import { Provider } from '../../../types/provider/Provider';

export const ProviderRepository = {
  create: (form: object): Promise<AxiosResponse<Provider>> => {
    return axiosIntance.post('/provider', form);
  },
  update: (form: object): Promise<AxiosResponse<Provider>> => {
    return axiosIntance.put('/provider', form);
  },
  delete: (form: object): Promise<AxiosResponse<{ sucess: boolean }>> => {
    return axiosIntance.delete('/provider', { data: form });
  },
};
